module.exports = __webpack_public_path__ + "static/24-fcff08a04d26c59bab7639f02f936df5.png";